import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutenticacaoModalComponent, ConfirmarAlteracoesModalComponent, NavbarComponent, ConfigsModalComponent } from "app/components";
import { ConfiguracaoValidadaModalComponent } from "./configuracao-validada-modal/configuracao-validada-modal.component";
import { ConfiguracoesAlimentadora, ConfiguracoesConnect, ConfiguracoesLicenca, ConfiguracaoCaixaTanque, ConfiguracaoControle, ConfiguracaoControleSensor, ConfiguracoesCaixasTanques, ConfiguracoesControles, DadosModal, DadosSelecionados, LicencasDisponiveis } from 'app/interfaces';
import { ConfiguracoesSyncService, ConfiguracoesService, ComunicadorService } from 'app/services';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

interface ObjetoAlteracao {
  license: string;
  mpaConfigEntity: any;
  feederConfigEntity: any;
  operationConfigEntity?: any;
}
type ConfiguracoesControlesResumidos = Record<string, { controladoras: number[]; sensores: number[]; }[] | null>;

@Component({
  selector: 'app-configuracao-licencas',
  standalone: true,
  imports: [CommonModule, ConfigsModalComponent, NavbarComponent, ConfirmarAlteracoesModalComponent, AutenticacaoModalComponent, ConfiguracaoValidadaModalComponent, FormsModule, TranslocoModule],
  templateUrl: './configuracao-licencas.component.html',
  styleUrl: './configuracao-licencas.component.css'
})

export class ConfiguracaoLicencasComponent implements OnInit {
  @Output() trocarTela: EventEmitter<string> = new EventEmitter<string>();
  @Input() informacoesEquipamento!: ConfiguracoesConnect;
  public imei!: string;
  public configuracoesCadastradas!: ConfiguracoesConnect;
  public erros?: { erro: string };
  public configSolidoAberta: boolean = false;
  public configLiquidoAberta: boolean = false;
  public confirmarAlteracaoModal: boolean = false;
  public modalAberto: boolean = false;
  public autenticarModal: boolean = false;
  public configValidarModal: boolean = false;
  public valoresSelecionados: number[] = [];
  public indisponiveisParaControladorSensorSelecionado: number[] = [];
  public dadosLicencaSelecionados: DadosSelecionados = {}
  public licenca: { [key: string]: boolean[] } = {
    solido: [
      false,
      false,
      false,
      false
    ],
    liquido: [
      false,
      false,
      false
    ]
  }
  public dadosConfiguracaoSelecionada: DadosModal = {
    item: "",
    tipoConfig: "",
    nomeConfig: "",
    controleConfig: "",
    disponiveis: [],
    quantMax: 0
  };
  public configuracoesAtivas: { [key: string]: boolean } = {
    muda: true,
    solido: false,
    liquido: false,
    mpa: true,
    alimentadora: false
  }
  public controladoraSensorSelecionadoAtual = {
    tipoInsumo: 'S',
    caixa: 0,
    tipo: 'sensores'
  }
  public licencasDisponiveis: LicencasDisponiveis = {
    solido: {
      sensores: [
        [
          1, 2, 3, 4
        ],
        [
          9, 10, 11, 12
        ]
      ],
      controladoras: [
        [
          2, 3
        ],
        [
          6, 7
        ],
      ]
    },
    liquido: {
      sensores: [
        [
          5, 6, 7, 8
        ],
        [
          13, 14
        ]
      ],
      controladoras: [
        [
          4, 5
        ],
        [
          8
        ]
      ]
    },
    muda: {
      sensores: [
        [
          1, 2
        ]
      ],
      controladoras: [
        [
          1
        ]
      ]
    }
  }
  public ultimosDadosLicencaSelecionados: DadosSelecionados = {
    S: [],
    L: [],
    M: []
  };
  public configuracoesControles: ConfiguracoesControles = [];
  public tiposControle = [
    {
      nomeFormatado: 'Muda',
      nome: 'muda',
    },
    {
      nomeFormatado: 'Sólido',
      nome: 'solido',
    },
    {
      nomeFormatado: 'Líquido',
      nome: 'liquido',
    },
    {
      nomeFormatado: 'MPA',
      nome: 'mpa',
    },
    {
      nomeFormatado: 'Alimentadora',
      nome: 'alimentadora',
    }
  ];
  public ultimoIndiceTanqueConfigurado!: number;

  constructor(
    private readonly comunicadorService: ComunicadorService,
    private readonly configuracoesService: ConfiguracoesService,
    private readonly configuracoesSyncService: ConfiguracoesSyncService,
  ) { }

  ngOnInit(): void {
    this.imei = this.configuracoesService.obterImei();
    this.obterDadosStringLicenca();
    this.observarMudancasWebscoket();
  }

  public mudarConfiguracoesAtivas(tipoControle: string): void {
    const indiceTipoControle: number | undefined = this.configuracoesControles.findIndex((configuracaoControle: ConfiguracaoControle) => configuracaoControle.tipoControle == tipoControle);
    const configuracaoEstaAtiva: boolean = this.configuracoesControles[indiceTipoControle].ativo;

    if (tipoControle == 'muda') this.configuracoesControles[indiceTipoControle].configuracoes[0].selecionado = !configuracaoEstaAtiva;

    this.configuracoesControles[indiceTipoControle].ativo = !configuracaoEstaAtiva;
  }

  public opcaoEstaAtiva(tipoControle: string): boolean {
    const configuracaoControle: ConfiguracaoControle | undefined = this.encontrarTipoControle(tipoControle);

    if (!configuracaoControle) return false;

    return configuracaoControle!.ativo;
  }

  public pegarDadosJaUsados(
    configuracaoControle: ConfiguracaoControle | undefined,
    numeroCaixaTanque: number,
    tipo: 'sensores' | 'controladoras'
  ): any {
    if (!configuracaoControle) return;

    return configuracaoControle.configuracoes
      .filter((configuracaoCaixaTanque: ConfiguracaoCaixaTanque) => configuracaoCaixaTanque.numeroCaixaTanque !== numeroCaixaTanque)
      .flatMap((configuracaoCaixaTanque: ConfiguracaoCaixaTanque) => configuracaoCaixaTanque[tipo] || [])
      .flatMap((configuracaoControleSensor: ConfiguracaoControleSensor) => configuracaoControleSensor.selecionados);
  }

  public receberDados(dados: any): void {
    this.alternarModal();
    if (!dados) {
      return;
    }

    const indiceControle: number = this.configuracoesControles.findIndex((configuracaoControle: ConfiguracaoControle) => this.dadosConfiguracaoSelecionada.controleConfig == configuracaoControle.tipoControle);

    const tipoConfiguracao: string = this.dadosConfiguracaoSelecionada.tipoConfig;
    const indiceCaixaTanque: number = this.ultimoIndiceTanqueConfigurado;

    (this.configuracoesControles[indiceControle].configuracoes[indiceCaixaTanque] as any)[tipoConfiguracao].selecionados = dados;
  }

  public configuracaoTem(configuracao: ConfiguracaoCaixaTanque, objeto: string): boolean {
    return (configuracao as any)[objeto].selecionados.length > 0;
  }

  public encontrarTipoControle(tipoControle: string): ConfiguracaoControle | undefined {
    return this.configuracoesControles.find((configuracaoControle: ConfiguracaoControle) => configuracaoControle.tipoControle == tipoControle);
  }

  public abrirModal(configuracaoCaixaTanque: ConfiguracaoCaixaTanque, tipoControle: string, nomeControle: string, tipo: "controladoras" | "sensores"): void {
    this.valoresSelecionados = configuracaoCaixaTanque[tipo].selecionados;
    const nomeConfig: string = this.tiposControle.find((tipoControle) => tipoControle.nomeFormatado == nomeControle)?.nome || 'Sem informação';
    this.dadosConfiguracaoSelecionada = {
      item: tipo == 'controladoras' ? 'controle' : 'sensor',
      tipoConfig: tipo,
      nomeConfig: nomeControle,
      controleConfig: nomeConfig,
      disponiveis: (this.licencasDisponiveis as any)[tipoControle][tipo],
      quantMax: configuracaoCaixaTanque[tipo].quantidadeMaxima
    }
    const controleConfiguracao: ConfiguracaoControle | undefined = this.encontrarTipoControle(nomeConfig);
    this.indisponiveisParaControladorSensorSelecionado = this.pegarDadosJaUsados(controleConfiguracao, configuracaoCaixaTanque.numeroCaixaTanque, tipo)
    this.ultimoIndiceTanqueConfigurado = configuracaoCaixaTanque.numeroCaixaTanque - 1;

    this.alternarModal();
  }

  public alternarModal(): void {
    this.modalAberto = !this.modalAberto;
  }

  public obterDadosStringLicenca(): void {
    const configLicenca: string | ConfiguracoesLicenca | undefined = this.configuracoesService.obterPorEntidade('License');
    let licenca: string = (configLicenca as ConfiguracoesLicenca).licenseCode;

    this.configuracoesControles = this.obterInformacoesControles(licenca);
  }

  public obterInformacoesControles(dados: string): any {
    let configuracoesControles: ConfiguracoesControles = [];
    const [cabecalho, ...partes] = dados.split('|');

    const configuracaoSolido: ConfiguracaoControle = { nomeControle: 'Sólido', tipoControle: 'solido', ativo: false, configuracoes: [] };
    const configuracaoLiquido: ConfiguracaoControle = { nomeControle: 'Líquido', tipoControle: 'liquido', ativo: false, configuracoes: [] };
    const configuracaoMuda: ConfiguracaoControle = { nomeControle: 'Muda', tipoControle: 'muda', ativo: false, configuracoes: [] };
    const configuracaoAlimentadora: ConfiguracaoControle = { nomeControle: 'Alimentadora', tipoControle: 'alimentadora', ativo: false, configuracoes: [] };
    const configuracaoMpa: ConfiguracaoControle = { nomeControle: 'MPA', tipoControle: 'mpa', ativo: false, configuracoes: [] };

    if (!cabecalho.includes('S0')) configuracaoSolido.ativo = true;
    if (!cabecalho.includes('L0')) configuracaoLiquido.ativo = true;
    if (!cabecalho.includes('M0')) configuracaoMuda.ativo = true;
    if (cabecalho.includes('A1')) configuracaoAlimentadora.ativo = true;
    if (cabecalho.includes('P1')) configuracaoMpa.ativo = true;

    configuracoesControles.push(configuracaoSolido);
    configuracoesControles.push(configuracaoLiquido);
    configuracoesControles.push(configuracaoMuda);
    configuracoesControles.push(configuracaoAlimentadora);
    configuracoesControles.push(configuracaoMpa);
    configuracoesControles = this.ordernarControles(configuracoesControles);

    const iniciaisTiposControle: { [key: string]: string } = {
      'S': 'solido',
      'L': 'liquido',
      'M': 'muda',
      'P': 'mpa',
      'A': 'alimentadora',
    };

    partes.forEach((parte) => {
      const regex = /^([A-Z])-(.+?)-(.*)$/;
      const match = parte.match(regex);

      if (!match) return;

      const tipoControle: string = iniciaisTiposControle[match[1]] || match[1];
      const controladorasStr: string | null = match[2];
      const sensoresStr: string | null = match[3];

      if (!controladorasStr || !sensoresStr) return;

      const controladoras = controladorasStr.split(',').map(Number);
      const sensores = sensoresStr.split(',').map(Number);

      let indiceTipoControle: number = configuracoesControles.findIndex((configControle: ConfiguracaoControle) => configControle.tipoControle == tipoControle);
      if (indiceTipoControle < 0) return;

      let configuracoesCaixasTanques: ConfiguracoesCaixasTanques = configuracoesControles[indiceTipoControle].configuracoes;
      const numeroCaixaTanque: number = configuracoesCaixasTanques.length + 1;

      configuracoesControles[indiceTipoControle].configuracoes.push({
        numeroCaixaTanque: numeroCaixaTanque,
        selecionado: true,
        controladoras: {
          quantidadeMaxima: 1,
          selecionados: controladoras
        },
        sensores: {
          quantidadeMaxima: 2,
          selecionados: sensores
        },
      });
    });
    const indiceSolido: number = configuracoesControles.findIndex((configControle) => configControle.tipoControle == configuracaoSolido.tipoControle);
    const indiceLiquido: number = configuracoesControles.findIndex((configControle) => configControle.tipoControle == configuracaoLiquido.tipoControle);
    const indiceMuda: number = configuracoesControles.findIndex((configControle) => configControle.tipoControle == configuracaoMuda.tipoControle);

    configuracoesControles[indiceSolido].configuracoes = this.finalizarPreenchimentoDeCaixasETanques(configuracoesControles[indiceSolido].configuracoes, 4);
    configuracoesControles[indiceLiquido].configuracoes = this.finalizarPreenchimentoDeCaixasETanques(configuracoesControles[indiceLiquido].configuracoes, 3);
    configuracoesControles[indiceMuda].configuracoes = this.finalizarPreenchimentoDeCaixasETanques(configuracoesControles[indiceMuda].configuracoes, 1);

    return configuracoesControles;
  }

  public finalizarPreenchimentoDeCaixasETanques(configuracoes: ConfiguracoesCaixasTanques, quantidadeMaximaCaixasTanques: number): ConfiguracoesCaixasTanques {
    const caixasTanquesSelecionados: number = configuracoes.length;

    for (let i: number = caixasTanquesSelecionados; i < quantidadeMaximaCaixasTanques; i++) {
      configuracoes[i] = {
        numeroCaixaTanque: i + 1,
        selecionado: false,
        sensores: {
          quantidadeMaxima: 2,
          selecionados: []
        },
        controladoras: {
          quantidadeMaxima: 1,
          selecionados: []
        },
      }
    }

    return configuracoes;
  }

  public ordernarControles(configuracoesControles: ConfiguracoesControles): ConfiguracoesControles {
    const ordemMap = new Map(this.tiposControle.map((obj, index) => [obj.nome, index]));
    return configuracoesControles.sort((a, b) => {
      return (ordemMap.get(a.tipoControle) ?? Infinity) - (ordemMap.get(b.tipoControle) ?? Infinity);
    });
  }

  public ordernarControlesParaGerarLicenca(tiposControles: string[]): string[] {
    const ordemControles: string[] = ['solido', 'liquido', 'muda', 'alimentadora', 'mpa'];
    const ordemMap = new Map(ordemControles.map((tipo, index) => [tipo, index]));

    return tiposControles.sort((a, b) => {
      return (ordemMap.get(a) ?? Infinity) - (ordemMap.get(b) ?? Infinity);
    });
  }

  public obterQuantidadeControladorasSelecionadas(obterSelecoesVazias: boolean = false): Record<string, number> {
    const configuracoesControles: ConfiguracoesControles = [...this.configuracoesControles];
    const resultado: Record<string, number> = {};

    configuracoesControles.forEach((configuracaoControle: ConfiguracaoControle) => {
      const quantidadeControladorasSelecionadas: number = configuracaoControle.configuracoes.filter(
        (configuracaoCaixaTanque: ConfiguracaoCaixaTanque) =>
          configuracaoCaixaTanque.selecionado === true &&
          (obterSelecoesVazias ? configuracaoCaixaTanque.controladoras.selecionados.length == 0 : configuracaoCaixaTanque.controladoras.selecionados.length > 0)
      ).length;

      resultado[configuracaoControle.tipoControle] = quantidadeControladorasSelecionadas;
    });

    return resultado;
  }

  public transformarControles(
    configuracoesControles: ConfiguracoesControles
  ): ConfiguracoesControlesResumidos {
    const resultado: ConfiguracoesControlesResumidos = {};

    configuracoesControles.forEach((configuracaoControle: ConfiguracaoControle) => {
      resultado[configuracaoControle.tipoControle] = configuracaoControle.ativo ? configuracaoControle.configuracoes
        .filter((configuracaoCaixaTanque: ConfiguracaoCaixaTanque) => configuracaoCaixaTanque.selecionado)
        .map((configuracaoCaixaTanque: ConfiguracaoCaixaTanque) => ({
          controladoras: configuracaoCaixaTanque.controladoras.selecionados,
          sensores: configuracaoCaixaTanque.sensores.selecionados
        })) : null;
    });

    return resultado;
  }


  public obterQuantidadeControladorasSelecionadasPorTipo(controladorasPorTipo: Record<string, number>, tipo: string): number {
    if (!controladorasPorTipo[tipo]) return 0;

    return controladorasPorTipo[tipo];
  }

  public gerarStringLicenca(): string {
    const configuracoesPorTipo = this.transformarControles(this.configuracoesControles);
    const tiposOrdenados = this.ordernarControlesParaGerarLicenca(Object.keys(configuracoesPorTipo));
    const iniciaisTipo: { [key: string]: string } = { solido: 'S', liquido: 'L', muda: 'M', mpa: 'P', alimentadora: 'A' };

    let cabecalho = '';
    const corpo: string[][] = [];

    for (const tipo of tiposOrdenados) {
      const inicial = iniciaisTipo[tipo];
      const configuracoes = configuracoesPorTipo[tipo];
      let quantidade = configuracoes?.length || 0;

      if (['mpa', 'alimentadora'].includes(tipo) && configuracoes) quantidade++;

      cabecalho += `${inicial}${quantidade}`;

      if (!configuracoes) continue;

      const dadosFormatados = this.obterControladoraSensoresFormatados(configuracoesPorTipo, tipo, inicial);
      corpo.push(dadosFormatados);
    }

    const corpoFormatado = corpo.flat().join('|');

    return `${cabecalho}|${corpoFormatado}`;
  }


  public obterControladoraSensoresFormatados(configuracoesPorTipoControle: ConfiguracoesControlesResumidos, tipoControle: string, inicialTipoControle: string): string[] {
    if (!configuracoesPorTipoControle[tipoControle]) return [''];

    return configuracoesPorTipoControle[tipoControle]
      .map(caixaTanque => inicialTipoControle + '-' + caixaTanque.controladoras.join(',') + '-' + caixaTanque.sensores.join(','));
  }

  public obterSelecoesControladorasVazias(): { erro: string } | undefined {
    const configuracoesSemControladora: Record<string, number> = this.obterQuantidadeControladorasSelecionadas(true);
    const tiposControles: string[] = Object.keys(configuracoesSemControladora);
    const valores: number[] = Object.values(configuracoesSemControladora);
    const valoresMaioresQueZero: number[] = valores.filter((valor: number) => valor > 0);

    if (valoresMaioresQueZero.length == 0) return;

    const indiceValor: number = valores.findIndex((valor: number) => valor == valoresMaioresQueZero[0]);

    return { erro: tiposControles[indiceValor] };
  }

  public confirmarAlteracao() {
    this.confirmarAlteracaoModal = true;
    this.erros = this.obterSelecoesControladorasVazias();
    this.gerarStringLicenca();
  }

  public receberConfirmarModal(resposta?: string): void {
    if (resposta) {
      if (resposta == 'confirmar') {
        this.autenticarModal = true;
      } else {
        this.irParaTelaConfigGerais();
      }
    }
    this.confirmarAlteracaoModal = false;
  }

  public receberDadosAutorizacaoModal(resposta?: boolean): void {
    if (!resposta) {
      this.autenticarModal = false;
      return;
    }

    const licenseString = this.gerarStringLicenca();
    const objetoAlteracao: ObjetoAlteracao = this.criarObjetoAlteracao(licenseString);

    this.abrirModalAtualizacaoFeita();
    this.atualizarConfiguracoes(objetoAlteracao);

    this.configuracoesSyncService.dispararNotificacaoEnvio();
    this.autenticarModal = false;
  }

  public criarObjetoAlteracao(license: string): ObjetoAlteracao {
    const objeto: ObjetoAlteracao = {
      license: license,
      mpaConfigEntity: this.obterMpaConfig(license),
      feederConfigEntity: this.obterAlimentadoraConfig(license),
    };

    if (license.includes('L0')) {
      objeto.operationConfigEntity = this.obterOperacaoConfigComTanqueZerado();
    }

    return objeto;
  }

  public obterMpaConfig(license: string): any {
    if (license.includes('P0')) {
      return null;
    }

    const mpa = this.configuracoesService.obterPorEntidade('MpaConfigEntity');;

    const arrayVazio: boolean = Array.isArray(mpa) && mpa.length === 0;
    const objetoVazio: boolean = typeof mpa === 'object' && mpa !== null && Object.keys(mpa).length === 0;

    if (arrayVazio || objetoVazio) {
      return {
        maxRangeLevel: 0,
        minRangeLevel: 0,
        autoPlant: false
      };
    }

    return mpa;
  }

  public obterAlimentadoraConfig(license: string): any {
    if (license.includes('A0')) {
      return null;
    }

    const config = this.configuracoesService.obterPorEntidade('FeederConfigEntity');

    const desabilitado: boolean =
      config !== null &&
      config?.covererMode === 'disabled';

    if (desabilitado) {
      return this.getAlimentadoraConfigDefault();
    }

    return config;
  }

  public getAlimentadoraConfigDefault(): ConfiguracoesAlimentadora {
    return {
      feederMode: 'disabled',
      covererMode: 'manual',
      doubleRampControlActivaded: false,
      maxLevelAllowedTreadmillHead: 0,
      maxLevelToTurnOffFeeder: 0,
      minLevelToTurnOnFeeder: 0,
      feederAdvanceTime: 0,
      feederRetreatTime: 0,
      retreatTimeToFuel: 0,
      minTensionBlockSensor: 0,
      maxTensionBlockSensor: 0,
      minPressureBlockSensor: 0,
      maxPressureBlockSensor: 0,
      covererControlActivated: false,
      leftFeederControlActivated: false,
      rightFeederControlActivated: false,
    };
  }

  public atualizarConfiguracoes(objetoAlteracao: ObjetoAlteracao): void {
    const {
      license,
      mpaConfigEntity,
      feederConfigEntity,
      operationConfigEntity
    } = objetoAlteracao;

    this.comunicadorService
      .atualizarConfiguracoes(this.imei, {
        License: license,
        MpaConfigEntity: mpaConfigEntity,
        FeederConfigEntity: feederConfigEntity,
        ...(operationConfigEntity && { OperationConfigEntity: operationConfigEntity })
      })
      .subscribe();

    this.configuracoesService.atualizarPorEntidade('License', { licenseCode: license });
    this.configuracoesService.atualizarPorEntidade('MpaConfigEntity', mpaConfigEntity);
    this.configuracoesService.atualizarPorEntidade('FeederConfigEntity', feederConfigEntity);

    if (operationConfigEntity) {
      this.configuracoesService.atualizarPorEntidade('OperationConfigEntity', operationConfigEntity);
    }
  }

  public abrirModalAtualizacaoFeita(): void {
    this.configValidarModal = true;
  }

  public receberDadosAtualizacaoFeitaModal(): void {
    this.configValidarModal = false;
  }

  public irParaTelaConfigGerais(): void {
    this.trocarTela.emit('configuracoes');
  }


  public obterOperacaoConfigComTanqueZerado(): object {
    let configuracaoOperacao = this.configuracoesService.obterPorEntidade('OperationConfigEntity');
    configuracaoOperacao.nominalCurrentTanks = []
    return configuracaoOperacao;
  }

  public observarMudancasWebscoket(): void {
    this.configuracoesService.obterPorEntidadeWebsocket('License')
      .subscribe(() => this.obterDadosStringLicenca());
  }

  public esvaziarControladorasSensoresSelecionadosConfiguracao(configuracaoCaixaTanque: ConfiguracaoCaixaTanque): ConfiguracaoCaixaTanque {
    configuracaoCaixaTanque.selecionado = !configuracaoCaixaTanque.selecionado;
    configuracaoCaixaTanque.controladoras.selecionados = [];
    configuracaoCaixaTanque.sensores.selecionados = [];

    return configuracaoCaixaTanque;
  }
}